"use client";

import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import { Clock, Loader, Mail, MapPin, Phone } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const channels = [{
  icon: Mail,
  label: "EMAIL · BEZPOŚREDNI",
  value: "biuro@budsys.pl",
  href: "mailto:biuro@budsys.pl",
  response: "ODPOWIEDŹ · 2H"
}, {
  icon: Phone,
  label: "TELEFON · KONTAKT",
  value: "+48 796 280 315",
  href: "tel:+48796280315",
  response: "ODPOWIEDŹ · NATYCHMIAST"
}, {
  icon: MapPin,
  label: "SIEDZIBA · BIURO",
  value: "ul. Cichy kącik 15, 43-220 Bojszowy Nowe, Śląsk",
  href: "#",
  response: "PN–PT · 8–16"
}];
function BenchForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="border border-border p-8 font-default">
        <div className="flex items-center gap-2 mb-4">
          <span className="size-2 rounded-md bg-[var(--chart-2)]" />
          <p className="text-xs uppercase tracking-widest text-[var(--chart-2)]">ZAPYTANIE WYSŁANE</p>
        </div>
        <p className="text-foreground mb-6 font-default">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="font-default uppercase text-xs tracking-widest">
          WYŚLIJ KOLEJNE →
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-8">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={control} name="name" render={({
        field
      }) => <FormItem>
              <FormLabel className="font-default uppercase text-[10px] tracking-[0.2em] text-muted-foreground">
                01 · IMIĘ I NAZWISKO
              </FormLabel>
              <FormControl>
                <Input placeholder="Jan Kowalski" className="border-0 border-b border-border rounded-md bg-transparent px-0 focus-visible:ring-0 focus-visible:border-primary h-10" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="project_type" render={({
        field
      }) => <FormItem>
              <FormLabel className="font-default uppercase text-[10px] tracking-[0.2em] text-muted-foreground">
                02 · RODZAJ INWESTYCJI
              </FormLabel>
              <FormControl>
                <Input placeholder="np. budowa domu, fundamenty" className="border-0 border-b border-border rounded-md bg-transparent px-0 focus-visible:ring-0 focus-visible:border-primary h-10" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={control} name="email" render={({
        field
      }) => <FormItem>
              <FormLabel className="font-default uppercase text-[10px] tracking-[0.2em] text-muted-foreground">
                03 · ADRES EMAIL
              </FormLabel>
              <FormControl>
                <Input type="email" placeholder="jan@example.com" className="border-0 border-b border-border rounded-md bg-transparent px-0 focus-visible:ring-0 focus-visible:border-primary h-10" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="phone" render={({
        field
      }) => <FormItem>
              <FormLabel className="font-default uppercase text-[10px] tracking-[0.2em] text-muted-foreground">
                04 · NUMER TELEFONU
              </FormLabel>
              <FormControl>
                <Input type="tel" placeholder="+48 000 000 000" className="border-0 border-b border-border rounded-md bg-transparent px-0 focus-visible:ring-0 focus-visible:border-primary h-10" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={control} name="preferred_date" render={({
        field
      }) => <FormItem>
              <FormLabel className="font-default uppercase text-[10px] tracking-[0.2em] text-muted-foreground">
                05 · PREFEROWANA DATA
              </FormLabel>
              <FormControl>
                <Input type="date" className="border-0 border-b border-border rounded-md bg-transparent px-0 focus-visible:ring-0 focus-visible:border-primary h-10 font-default" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="time_slot" render={({
        field
      }) => <FormItem>
              <FormLabel className="font-default uppercase text-[10px] tracking-[0.2em] text-muted-foreground">
                06 · PREFEROWANA PORA
              </FormLabel>
              <FormControl>
                <Select onValueChange={field.onChange} value={field.value}>
                  <SelectTrigger className="border-0 border-b border-border rounded-md bg-transparent px-0 focus-visible:ring-0 focus-visible:border-primary h-10 w-full font-default">
                    <SelectValue placeholder="Wybierz porę" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="08:00 – 10:00">08:00 – 10:00</SelectItem>
                    <SelectItem value="10:00 – 12:00">10:00 – 12:00</SelectItem>
                    <SelectItem value="12:00 – 14:00">12:00 – 14:00</SelectItem>
                    <SelectItem value="14:00 – 16:00">14:00 – 16:00</SelectItem>
                  </SelectContent>
                </Select>
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <FormField control={control} name="additional_details" render={({
      field
    }) => <FormItem>
            <FormLabel className="font-default uppercase text-[10px] tracking-[0.2em] text-muted-foreground">
              07 · WIADOMOŚĆ
            </FormLabel>
            <FormControl>
              <Textarea placeholder="// opisz zakres prac, lokalizację inwestycji..." rows={5} className="border-0 border-b border-border rounded-md bg-transparent px-0 focus-visible:ring-0 focus-visible:border-primary font-default placeholder:text-muted-foreground/60" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="shipping_gear" render={({
      field
    }) => <FormItem className="flex flex-row items-center gap-3 space-y-0">
            <FormControl>
              <Checkbox checked={field.value} onCheckedChange={field.onChange} />
            </FormControl>
            <FormLabel className="font-default uppercase text-[11px] tracking-[0.15em] text-muted-foreground cursor-pointer">
              Wyrażam zgodę na kontakt w sprawie wyceny
            </FormLabel>
          </FormItem>} />

      {submitError && <div className="p-4 border border-destructive/40 bg-destructive/10">
          <p className="text-destructive font-default text-xs uppercase tracking-widest">{submitError}</p>
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full h-14 bg-primary hover:bg-primary/90 text-primary-foreground font-default uppercase tracking-[0.2em] text-sm rounded-md">
        {isSubmitting ? <>
            <Loader className="animate-spin mr-2 size-4" />
            WYSYŁANIE...
          </> : "WYŚLIJ ZAPYTANIE →"}
      </Button>

      <div className="flex justify-center mt-4">
        <div className="cursor-pointer" role="link" tabIndex={0} onClick={() => window.open("https://wizytowka.rzetelnafirma.pl/6ACNYO29S9HRCY1S", "_blank", "noopener")}>
          <img src="https://aktywnybaner.rzetelnafirma.pl/ActiveBanner/GetActiveBannerImage/44/6ACNYO29S9HRCY1S" style={{
          border: "none"
        }} alt="Rzetelna Firma - baner aktywny" />
        </div>
      </div>
    </Form>;
}
export default function Contact() {
  const heading = useRevealOnScroll<HTMLDivElement>();
  const form = useRevealOnScroll<HTMLDivElement>();
  const cards = useRevealOnScroll<HTMLDivElement>();
  return <section data-section-id="4979" id="dane-kontaktowe" className="bg-background text-foreground relative overflow-hidden pt-[200px] pb-32 px-6 md:px-12 lg:px-20">
      <div className="absolute top-12 left-6 md:left-12 flex items-center gap-2 font-default text-[10px] tracking-widest text-muted-foreground/60">
        <span className="size-2 border border-muted-foreground/60" />
        <span>BUDSYS · KONTAKT</span>
      </div>
      <div className="absolute top-12 right-6 md:right-12 flex items-center gap-2 font-default text-[10px] tracking-widest text-muted-foreground/60">
        <span>ŚLĄSK · INWESTYCJE</span>
        <span className="size-2 border border-muted-foreground/60" />
      </div>

      <div aria-hidden className="absolute inset-0 opacity-[0.04] pointer-events-none" style={{
      backgroundImage: "linear-gradient(var(--foreground) 1px, transparent 1px), linear-gradient(90deg, var(--foreground) 1px, transparent 1px)",
      backgroundSize: "80px 80px"
    }} />

      <div className="relative max-w-7xl mx-auto">
        <div ref={heading.ref} className={`mb-20 transition-all duration-700 ${heading.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="flex items-center gap-3 mb-8">
            <span className="size-1.5 rounded-md bg-primary" />
            <p className="font-default text-xs uppercase tracking-[0.3em] text-muted-foreground">
              § ZAPRASZAMY DO WSPÓŁPRACY
            </p>
          </div>

          <h1 className="font-default font-bold tracking-tighter leading-[0.9] text-foreground text-6xl md:text-8xl lg:text-[110px]">
            ZACZNIJMY
            <span className="text-muted-foreground/40"> / </span>
            <br />
            BUDOWĘ.
          </h1>

          <div className="mt-8 flex items-center gap-4 max-w-2xl">
            <div className="h-px flex-1 bg-border" />
            <p className="font-default text-[11px] uppercase tracking-[0.2em] text-muted-foreground">
              KOMPLEKSOWE USŁUGI BUDOWLANE · ŚLĄSK · DARMOWA WYCENA
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-11 gap-12 lg:gap-0 relative">
          <div aria-hidden className="hidden lg:block absolute left-[63.6%] top-0 bottom-0 w-px">
            <div className="absolute inset-0 bg-border" />
            <div className="absolute top-0 -left-1.5 size-3 border border-muted-foreground/60" />
            <div className="absolute top-1/2 -left-1.5 size-3 border border-muted-foreground/60 -translate-y-1/2" />
            <div className="absolute bottom-0 -left-1.5 size-3 border border-muted-foreground/60" />
          </div>

          <div ref={form.ref} className={`lg:col-span-7 lg:pr-16 transition-all duration-700 ${form.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <div className="mb-10">
              <p className="font-default text-[11px] uppercase tracking-[0.25em] text-primary mb-3">
                / FORMULARZ · KONTAKTOWY
              </p>
              <p className="font-default text-muted-foreground max-w-lg">
                Wypełnij formularz, aby otrzymać bezpłatną wycenę lub umówić się na wizytę na budowie. Nasz zespół odpowie na Twoje zapytanie w ciągu 2 godzin.
              </p>
            </div>

            <FormProvider formKey="contact_form_contact" formId="contact_form_contact" sectionName="dane-kontaktowe" defaultValues={{
            name: "",
            email: "",
            phone: "",
            preferred_date: "",
            time_slot: "",
            project_type: "",
            additional_details: ""
          }} validationRules={{
            name: {
              required: true
            },
            email: {
              required: true,
              pattern: "email"
            },
            phone: {
              required: true,
              pattern: "phone"
            },
            preferred_date: {
              required: true
            },
            time_slot: {
              required: true
            }
          }} submitText="WYŚLIJ ZAPYTANIE" successMessage="Dziękujemy za kontakt. Nasz doradca skontaktuje się z Tobą wkrótce." errorMessage="Wystąpił błąd podczas wysyłania. Spróbuj ponownie później.">
              <BenchForm />
            </FormProvider>
          </div>

          <div ref={cards.ref} className={`lg:col-span-4 lg:pl-16 lg:pt-24 space-y-6 transition-all duration-700 ${cards.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <div className="mb-2">
              <p className="font-default text-[11px] uppercase tracking-[0.25em] text-primary">
                / DANE · KONTAKTOWE
              </p>
            </div>

            {channels.map((channel, i) => {
            const Icon = channel.icon;
            return <div key={i} data-index={i} className="border border-border p-8 hover:border-primary/60 transition-colors duration-300 relative group rounded-md">
                  <div className="flex items-start justify-between mb-5">
                    <Icon className="size-5 text-primary stroke-[1.5]" />
                    <span className="font-default text-[9px] tracking-[0.2em] text-muted-foreground/60">
                      CH/0{i + 1}
                    </span>
                  </div>

                  <p className="font-default text-[10px] uppercase tracking-[0.25em] text-muted-foreground mb-3">
                    {channel.label}
                  </p>

                  {channel.href !== "#" ? <Link to={channel.href} className="font-default text-foreground text-lg leading-snug block hover:text-primary transition-colors break-words">
                      {channel.value}
                    </Link> : <p className="font-default text-foreground text-lg leading-snug break-words">
                      {channel.value}
                    </p>}

                  <div className="mt-6 pt-4 border-t border-border/60 flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <span className="size-1.5 rounded-md bg-[var(--chart-2)]" />
                      <span className="font-default text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
                        {channel.response}
                      </span>
                    </div>
                    <Clock className="size-3 text-muted-foreground/60" />
                  </div>
                </div>;
          })}

            <div className="pt-6 flex items-center gap-3 font-default text-[10px] uppercase tracking-[0.2em] text-muted-foreground/60">
              <span className="h-px flex-1 bg-border" />
              <span>KONIEC · DANYCH</span>
              <span className="size-1.5 rounded-md border border-muted-foreground/60" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}